import React from 'react';
import MaterialPopover from '@mui/material/Popover';
import Typography from '../Typography';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";

const Popover = ({ open, handlePopoverClose, anchorEl, text }) => {

    const useStyles = makeStyles((theme) => ({
        popover: {
            pointerEvents: 'none',
        },
        paper: {
            padding: theme.spacing(1),
        },
    }));
    const classes = useStyles();


    return (
        <div>
            <MaterialPopover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open} q
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography text={text} color="darkGray" />
            </MaterialPopover>
        </div>
    );
}

Popover.propTypes = {
    open: PropTypes.bool,
    handlePopoverClose: PropTypes.func,
    anchorEl: PropTypes.any,
    text: PropTypes.string
};
export default Popover;